import React, { FC, useEffect, useState } from 'react'
import { observer } from 'mobx-react'
import { doProductMobx, menuMobx, productSaleMobx } from 'restaurant'
import { SoldoutFoldBar } from '@cps'
import { format } from '@dt/fe-utils'
import { decorationMobx } from '@mobxStore'
import { filter, find, sortBy } from '@dt/fe-utils/dist/lodash'
import CashierController from '@ctrls/cashierController'
import './index.scss'

interface IProps {
  group: IDoModifierGroup;
  subsColor?: string; // 不能打包
  hideModifyDiscount?: boolean;
}

const MultiModify: FC<IProps> = ({ group, subsColor, hideModifyDiscount }) => {
  const [modifiers, setModifiers] = useState<IDoModifierGroupItem[]>([])
  const soldoutKey = `${doProductMobx.doProduct.no}_${group.no}`
  // 判断是否展示售罄
  const showSoldout = menuMobx.openFoldSoldoutScale === 1 && !!find(group.modifiers, modify => productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt === 0)

  useEffect(() => {
    const modifiers = !showSoldout || menuMobx.foldSoldoutMap?.[soldoutKey] === true
      ? sortBy(group.modifiers || [], (modify) => productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt === 0 ? 1 : 0)
      : filter(group.modifiers, modify => !(productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]?.cnt === 0))
    setModifiers([...modifiers])
  }, [group, menuMobx.foldSoldoutMap?.[soldoutKey], showSoldout])

  return (
    <div key={group.no} className='modify-item'>
      <div
        // className='title space-between'
        className={group.selectMin === 0 ? 'titlemin space-between' : 'title space-between'}
      >
        <span>{group.name}</span>
        <span
          style={{ display: doProductMobx.doProduct.saleCnt === 0 ? 'none' : 'block' }}
          className={`${!group.isReady && subsColor}`}
        >
          {group.selectMin === group.selectMax ? i18n.t('productdetail.requireCount', { count: group.selectMin }) : group.selectMin === 0 ? i18n.t('productdetail.optional', { count: group.selectMax }) : i18n.t('productdetail.selectMulit', { min: group.selectMin, max: group.selectMax })}
        </span>
      </div>
      <div className='content'>
        {
          modifiers.map(modify => {
            const saleCnt = productSaleMobx.localScaleNoToCntMap[`${modify.no}_0`]
            const stopSale = saleCnt && saleCnt.cnt === 0
            const price = modify.price
            const actualPrice = !hideModifyDiscount && modify.discountPrice && modify.discountPrice > 0 ? modify.actualPrice : modify.price
            return (
              <div
                className={`item ${modify.cnt > 0 ? 'selected' : ''} ${stopSale ? 'disabled' : ''}`}
                key={modify.no}
                data-cypid={`chooseModify_no_${modify.no}`}
                onClick={() => {
                  !stopSale && CashierController.chooseModify(group, modify)
                }}
              >
                <h6 className={`${!price ? 'no-price' : ''}`}>{modify.name}</h6>
                {!stopSale && price ? <span className='price'>{format.toPrice(actualPrice)} {actualPrice !== price && <del> {format.toPrice(price)}</del>}</span> : null}
                {decorationMobx.mealDecorates.showSalesCnt && !stopSale && saleCnt?.cnt > 0 ? <span className='sub-price-limit'>{`(${i18n.t('cart.limit')}: ${saleCnt.cnt})`}</span> : null}
                {stopSale ? <span className='sub-price-limit'>{i18n.t('common.soldout')}</span> : null}
              </div>
            )
          })
        }
        {!!showSoldout && (
          <SoldoutFoldBar
            className='item'
            show={menuMobx.foldSoldoutMap?.[soldoutKey] === true}
            no={soldoutKey}
            from='modify'
          />
        )}
      </div>
    </div>
  )
}

export default observer(MultiModify)
